import { useTranslation } from 'react-i18next';

const CartFullModal = (props) => {
  const { t } = useTranslation();
  const { show, setCartFull } = props;
  if (show) {
    return (
      // <Modal show={show} onHide={setCartFull(false)}>
      <div
        className="fullcart-modal"
        onClick={() => {
          setCartFull(false);
        }}
      >
        <div className="fullcart-modal-container">
          <div className="fullcart-modal-title">{t(`Oops`)}!</div>
          <div className="fullcart-modal-title1">{t(`Your cart is full`)}.</div>
          <div className="fullcart-modal-title2">
            {t(`Please checkout with your current items before placing another order.`)}
          </div>
        </div>
      </div>
    );
  } else return null;
};

export default CartFullModal;
